module.exports = __webpack_public_path__ + "img/legatravel.92747dca.jpg";